import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData1 } from "../service/api";
import {
  setHeaderData,
  setFooter,
  setPageSearch,
  setLoader,
  setExpirationTime,
} from "@/redux/dataSlice";
import { EDUCATION_PAGE1 } from "@/utils/constants";
import LoadingSpinner from "@/components/LoadingSpinner";

const useHeaderFooter = () => {
  const dispatch = useDispatch();
  const { headerData, isFooter, isPageSearch, loader,expirationTime } = useSelector(
    (state: any) => state?.data
  );

  const fetchDataAsync = async () => {
    dispatch(setLoader(true));
    try {
      const response = await fetchData1(EDUCATION_PAGE1);

      const data = response?.data?.data;
      const getHeader = data?.aedheader;
      const getFooters = data?.aedfooter;
      const getPagesearch = data?.aedpagesearch;

      if (!data) {
        dispatch(setLoader(true));
        dispatch(setHeaderData(null));
        dispatch(setFooter(null));
        dispatch(setPageSearch(null));
      } else {
        dispatch(setHeaderData({ aedheader: getHeader }));
        dispatch(setFooter({ aedfooter: getFooters }));
        dispatch(setPageSearch({ aedpagesearch: getPagesearch }));
        dispatch(setExpirationTime());
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    if (!headerData || !isFooter || !isPageSearch || Date.now() > expirationTime) {
      fetchDataAsync();
    }
  }, [headerData, isFooter, isPageSearch,expirationTime, dispatch]);
  return loader ? <LoadingSpinner /> : null;
};

export default useHeaderFooter;
